import { Link } from 'react-router-dom';
import HeaderEn from '@/components/en/HeaderEn';
import FooterEn from '@/components/en/FooterEn';
import { Button } from '@/components/ui/button';

const NotFoundEn = () => {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <HeaderEn />
      <main className="flex-grow flex items-center justify-center pt-20">
        <div className="text-center px-6 py-16">
          <h1 className="text-9xl font-bold text-electric-cyan mb-4">404</h1>
          <h2 className="text-4xl font-bold text-foreground mb-6">
            Page Not Found
          </h2>
          <p className="text-xl text-muted-foreground mb-8 max-w-md mx-auto">
            We couldn't find the page you're looking for. It may have been moved or removed.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/en/">
              <Button size="lg" className="min-w-[200px]">
                Go to Homepage
              </Button>
            </Link>
            <Link to="/en/about">
              <Button variant="outline" size="lg" className="min-w-[200px]">
                Contact Us
              </Button>
            </Link>
          </div>
        </div>
      </main>
      <FooterEn />
    </div>
  );
};

export default NotFoundEn;
